import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import classNames from './ImageMenu.css'
import { fetchQueues, saveQueue } from '../../redux/queues'
import { showBanner } from '../../redux/banners'
import DropMenu from '../DropMenu'
import LoadingSpinner from '../LoadingSpinner'
import Icon from '../Icon'
import AddImagesToAlbum from '../album/AddImagesToAlbum'
import ImageShare from '../album/ImageShare'
import ChannelMenuItem from '../present/ChannelMenuItem'
import { getImageSize } from '../../utils/images'
import { userHasPerm, canDownload } from '../../utils/auth'
import { picassoFetch } from '../../utils/fetch'
import { IS_IOS } from '../../constants'

class ImageMenu extends Component {
  state = {
    open: false,
    downloadMenuOpen: false,
    shareMenuOpen: false,
    addMenuOpen: false,
    playNowMenuOpen: false,
    playNextMenuOpen: false,
    channels: null
  }
  getPresentMenuItems () {
    const { channels, playNowMenuOpen } = this.state
    if (!channels) {
      return [{
        text: <LoadingSpinner style={{ width: '12px', height: '12px', margin: 0 }} />
      }]
    }
    const items = []
    if (playNowMenuOpen) {
      items.push({
        key: 'blank',
        text: 'Play on this device',
        onClick: () => this.onAddToChannel({}, playNowMenuOpen)
      })
    }
    if (channels.length !== 0) {
      items.push({
        heading: 'Add to channel'
      })
    }
    return items.concat(channels.map(channel => ({
      key: channel.id,
      text: <ChannelMenuItem channel={channel} />,
      onClick: () => this.onAddToChannel(channel, playNowMenuOpen)
    })))
  }
  onAddToChannel = (channel, playNow) => {
    const { sendToPlayNow, sendToPlayNext, showBanner } = this.props
    const structure = this.props.albumID ? { album: { album: this.props.albumID } } : { images: this.props.images }
    const success = data => {
      if (!channel.id && playNow) {
        this.props.presentChannel(data.channel)
      } else {
        showBanner(this.props.albumID ? 'Album added to channel' : 'Images added to channel')
      }
    }
    if (playNow) {
      sendToPlayNow(channel.id, structure).then(success)
    } else {
      sendToPlayNext(channel.id, structure).then(success)
    }
  }
  getDownloadItem (text, code) {
    const { image, getImageSource } = this.props
    const { width, height } = getImageSize(code, image._width, image._height)
    return {
      text: `${text} (${width} x ${height})`,
      href: getImageSource(image._id, code),
      target: '_blank',
      download: true
    }
  }
  render () {
    const { image, setCover, showInfoLink, anonymousUser, canEditPlaylists, fetchChannels, onClickInfo } = this.props
    const state = this.state
    const presentMenuItems = this.getPresentMenuItems()

    return (
      <div>
        <div className={classNames.menu} style={this.props.style}>
          {this.props.onClickFullscreen && !IS_IOS &&
            <button onClick={this.props.onClickFullscreen}>
              <Icon icon='fullscreen' size={24} />
            </button>
          }
          <button onClick={() => {
            this.setState({ open: !state.open })
            this.props.onOpen && this.props.onOpen()
          }} data-toggle='image-menu'>
            <Icon icon='dots' />
          </button>
          {showInfoLink &&
            <button onClick={onClickInfo}>
              <Icon icon='info' />
            </button>
          }
        </div>
        <DropMenu
          toggle='image-menu'
          fixed
          style={{ top: '44px' }}
          open={state.open}
          closeMenu={() => {
            this.setState({ open: false })
            this.props.onClose && this.props.onClose()
          }}
          items={[
            {
              text: `Play ${this.props.albumID ? 'album' : 'images'} now`,
              onClick: () => {
                this.setState({
                  channels: null,
                  playNowMenuOpen: true
                })
                fetchChannels().then(channels => this.setState({ channels }))
              },
              shouldShow: canEditPlaylists && !this.props.hidePresentOptions
            },
            {
              text: `Play ${this.props.albumID ? 'album' : 'images'} next`,
              onClick: () => {
                this.setState({
                  channels: null,
                  playNextMenuOpen: true
                })
                fetchChannels().then(channels => this.setState({ channels }))
              },
              shouldShow: canEditPlaylists && !this.props.hidePresentOptions
            },
            {
              text: 'Add image to album',
              onClick: () => this.setState({ addMenuOpen: true }),
              shouldShow: !anonymousUser
            },
            {
              text: 'Share image',
              onClick: () => this.setState({ shareMenuOpen: true }),
              shouldShow: this.props.canShareInternal || this.props.canShareExternal
            },
            {
              text: 'Download',
              onClick: () => this.setState({ downloadMenuOpen: true }),
              shouldShow: this.props.canDownload
            },
            {
              text: `Remove image from album`,
              onClick: () => {
                this.props.excludeImages([image._id])
                this.setState({ open: false })
              },
              shouldShow: this.props.canRemove
            },
            {
              text: 'Set image as album cover',
              onClick: () => setCover(image._id),
              shouldShow: !!setCover
            }
          ]}
        />
        <DropMenu
          fixed
          style={{ top: '44px' }}
          open={state.downloadMenuOpen}
          closeMenu={() => this.setState({ downloadMenuOpen: false })}
          items={[
            this.getDownloadItem('Small', 's75'),
            this.getDownloadItem('Medium', 'm75'),
            this.getDownloadItem('Large', 'l75'),
            this.getDownloadItem('Original', 'o')
          ]}
        />
        <DropMenu
          fixed
          style={{ top: '44px' }}
          open={state.playNowMenuOpen}
          closeMenu={() => this.setState({ playNowMenuOpen: false })}
          items={presentMenuItems}
        />
        <DropMenu
          fixed
          style={{ top: '44px' }}
          open={state.playNextMenuOpen}
          closeMenu={() => this.setState({ playNextMenuOpen: false })}
          items={presentMenuItems}
        />
        {state.addMenuOpen &&
          <AddImagesToAlbum
            images={[image._id]}
            onCancel={() => this.setState({ addMenuOpen: false })}
          />
        }
        {state.shareMenuOpen &&
          <ImageShare
            images={[image._id]}
            canShareInternal={this.props.canShareInternal}
            canShareExternal={this.props.canShareExternal}
            onCancel={() => this.setState({ shareMenuOpen: false })}
          />
        }
      </div>
    )
  }
}

const mapStateToProps = ({ queues, entities, auth }) => {
  return {
    queues: queues.data && queues.data.map(id => entities.queues[id]),
    fetchingQueues: queues.fetching,
    canEditPlaylists: userHasPerm(auth.user, 'create_channels'),
    canDownload: canDownload(auth),
    fetchChannels: () => picassoFetch(auth, 'list_channels')
      .then(data => data.channels.filter(c => parseInt(c.owner_id) === auth.user.id)),
    sendToPlayNext: (channelID, body) => picassoFetch(auth, 'add_to_play_next', {
      channel_id: channelID,
      ...body
    }),
    sendToPlayNow: (channelID, body) => picassoFetch(auth, 'add_to_play_now', {
      channel_id: channelID,
      ...body
    })
  }
}

const mapDispatchToProps = {
  fetchQueues,
  saveQueue,
  showBanner,
  presentChannel: id => dispatch => dispatch(push(`/present/${id}`))
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageMenu)



// WEBPACK FOOTER //
// ./src/components/image/ImageMenu.js